import React from "react";
import { useNavigate } from "react-router-dom";

const ErrorLayer = () => {
  // to navigate to different pages
  const navigate = useNavigate();
  
  const handleBack = () => {
    navigate(-1);
  }
  return (
    <div className=''>
      <div className='card-body py-80 px-32 text-center'>
        <img src='assets/images/error-img.png' alt='' className='mb-24' />
        <h6 className='mb-16'>Page not Found</h6>
        <p className='text-secondary-light'>
          Sorry, the page you are looking for doesn’t exist{" "}
        </p>
        <button onClick={handleBack} className='btn btn-primary-600 radius-8 px-20 py-11'>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default ErrorLayer;
